export const environment = {
  production: true,
  apiUrl: '', // use same host for static assets
  useWooCommerce: true,
  wooCommerceUrl: 'https://www.wasombouw.nl/wp-json/wc/v3',
  wooCommerceKey: 'ck_eb94055addfcd659dcc554fa9d8dfdd759d532db',
  wooCommerceSecret: 'cs_8ea0dc2a6ad06010612e8e357a3e5b6a4219b4d8',
  siteUrl: 'https://wasombouw.nl',
  cartUrl: 'https://wasombouw.nl/cart/?add-to-cart=',
  parentOrigin: 'https://wasombouw.nl',
  // No Basic Auth on production
  stagingUser: '',
  stagingPassword: '',
};
